module.exports = __webpack_public_path__ + "images/category_lp/watch_samples/a01_sp_f78b456181b18fecbd505b7ec2732050.png";